const CustomRadioButton = ({
  name,
  options = [],
  value,
  onChange,
  topLabel,
  disabled = false,
  isInsideInput = false, 
}) => {
  const styles = {
    radioWrapper: {
      width: "100%",
    },
  
    topLabel: {
      display: "block",
      fontSize: "14px",
      color: "#1E1E1E",
      fontWeight: "700",
      fontFamily: "'Open Sans', sans-serif",
    },
  
    radioContainer: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      columnGap: "16px", 
      rowGap: "0px",     
    },
    radioOption: {
      display: "flex",
      alignItems: "center",
      padding: isInsideInput ? "0 16px" : "0px",
      border: "1px solid #B5B5B5",
      cursor: "pointer",
      transition: "all 0.2s ease",
      backgroundColor: "white",
      height: "52px",
      minWidth: isInsideInput ? "160px" : "",
      fontFamily: "'Open Sans', sans-serif",
      gap: "8px",
      maxWidth: "100%",
    },
  
    radioInput: {
      appearance: "none",
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      position: "relative",
      backgroundColor: "white",
      display: "inline-block",
      border: "1px solid #B5B5B5",
      transition: "all 0.2s ease",
    },
  
    radioInputSelected: {
      backgroundColor: "#DB0035",
      boxShadow: "0 0 0 2px white, 0 0 0 3px #DB0035",
      border: "none",
    },
  
    radioLabel: {
      fontSize: "14px",
      color: "#1E1E1E",
      cursor: "pointer",
      userSelect: "none",
    },
  };

  const handleOptionClick = (optionValue) => {
    if (disabled) return;

    if (onChange) {
      onChange({
        target: {
          name,
          value: optionValue,
        },
      });
    }
  };

  const getRadioOptionStyle = (optionValue) => {
    const isSelected = value === optionValue;

    return {
      ...styles.radioOption,
      ...(isSelected ? styles.radioOptionSelected : {}),
      ...(disabled ? { opacity: 0.6, cursor: "not-allowed" } : {}),
      ...(isInsideInput ? {} : { border: "none", cursor:'pointer' }),
    };
  };

  const getRadioInputStyle = (optionValue) => {
    const isSelected = value === optionValue;

    return {
      ...styles.radioInput,
      ...(isSelected ? styles.radioInputSelected : {}),
      ...(disabled ? { cursor: "not-allowed" } : {}),
    };
  };


  return (
    <div style={styles.radioWrapper}>
      {topLabel && <label style={styles.topLabel}>{topLabel}</label>}

      <div style={styles.radioContainer}>
        {options.map((option) => (
          <div
            key={option.value}
            style={getRadioOptionStyle(option.value)}
            onClick={() => handleOptionClick(option.value)}
          >
            <div
              style={{
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => handleOptionClick(option.value)}
                style={getRadioInputStyle(option.value)}
                disabled={disabled}
              />
            </div>

            <label style={styles.radioLabel}>{option.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomRadioButton;
